export default __webpack_public_path__ + "static/media/TL12.de7d5543.mp3";